import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AccountService } from './account.service';

@Injectable({
  providedIn: 'root'
})
export class AuxiliarService {

  constructor(
    private accountService: AccountService,
    private router: Router,
    ) { }

  sessionExpired() {
    this,this.accountService.logout();
    this.router.navigate(['']);    
  }
}
